import { render, staticRenderFns } from "./AddUserToCohort.vue?vue&type=template&id=56109298&scoped=true&"
import script from "./AddUserToCohort.vue?vue&type=script&lang=js&"
export * from "./AddUserToCohort.vue?vue&type=script&lang=js&"
import style0 from "./AddUserToCohort.vue?vue&type=style&index=0&id=56109298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56109298",
  null
  
)

export default component.exports